<template>    
  <v-menu v-model="showMenu"
          :position-x="x"
          :position-y="y"
          absolute
          offset-y
    >
 <v-list>                
      <v-list-tile v-for="style in stylesList" :key="style.name" 
                  @click="$store.myActions.UI_SET_ITEM_MAP_STYLE({uiid:mission_uiid,style,colorType:'mission'})">
            <v-list-tile-avatar :class="style.name"  size="25" small :color="style.color"></v-list-tile-avatar>      
              <v-list-tile-title>{{ style.name }}</v-list-tile-title>
      </v-list-tile>
    </v-list>
    </v-menu>
</template>
<script>
  import MapToolList from '@/components/map/MapToolList'
  import { mapGetters } from 'vuex'    
  import {stylesList} from '@/components/map/MapStyles'  
  import {buildMissionUIStateId} from '@/models/ui/MissionUiState'
  export default {    
    name: 'MapContextMenu',        
    components: {MapToolList},
    props:{
      uiid:{
          type: String,
          required: true
      }
   },
    data() {
      return {
        showMenu: false,
        x: 0,
        y: 0,
        stylesList,
        missionId:0
      }
    },
    computed : {    
      ...mapGetters([
        'uistatebyuiid'
      ]),
      //recupere le state de travail
      mapstate() { 
        //retourne un MapUiState
        return this.uistatebyuiid(this.uiid)          
      },   
      mission_uiid() {
        return buildMissionUIStateId(this.missionId,this.mapstate.typeUiid)
      }
    },
    methods: {    
      show (e,missionId) {
        e.preventDefault()
        this.showMenu = false
        this.x = e.clientX
        this.y = e.clientY
        this.missionId = missionId
        this.$nextTick(() => {
          this.showMenu = true
        })
      }
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>

</style>
